// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1J6qW","topBottomGutter":"Layout_topBottomGutter__285QH"};